/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { MessageContentDto, MessageDto, MessageRequestDto } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class AdminMessageService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags AdminMessageService
   * @name GetMessageById
   * @summary Get Message by ID
   * @request GET:/v1/admin/messages/{messageId}
   * @secure
   */
  getMessageById = (messageId: number, params: RequestParams = {}) =>
    this.http.request<MessageDto, any>({
      path: `/v1/admin/messages/${messageId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description 기존 메시지를 수정합니다.
   *
   * @tags AdminMessageService
   * @name UpdateMessage
   * @summary Update Message
   * @request PUT:/v1/admin/messages/{messageId}
   * @secure
   */
  updateMessage = (messageId: number, data: MessageRequestDto, params: RequestParams = {}) =>
    this.http.request<MessageDto, any>({
      path: `/v1/admin/messages/${messageId}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminMessageService
   * @name DeleteMessage
   * @summary Delete Message
   * @request DELETE:/v1/admin/messages/{messageId}
   * @secure
   */
  deleteMessage = (messageId: number, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/messages/${messageId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminMessageService
   * @name GetMessageContent
   * @summary Get Message Content by ID
   * @request GET:/v1/admin/messages/{messageId}/contents/{languageId}
   * @secure
   */
  getMessageContent = (messageId: number, languageId: number, params: RequestParams = {}) =>
    this.http.request<MessageContentDto, any>({
      path: `/v1/admin/messages/${messageId}/contents/${languageId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description 기존 메시지 콘텐츠를 수정합니다.
   *
   * @tags AdminMessageService
   * @name UpdateMessageContent
   * @summary Update Message Content
   * @request PUT:/v1/admin/messages/{messageId}/contents/{languageId}
   * @secure
   */
  updateMessageContent = (
    messageId: number,
    languageId: number,
    data: MessageContentDto,
    params: RequestParams = {},
  ) =>
    this.http.request<MessageContentDto, any>({
      path: `/v1/admin/messages/${messageId}/contents/${languageId}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description 새로운 메시지 콘텐츠를 생성합니다.
   *
   * @tags AdminMessageService
   * @name CreateMessageContent
   * @summary Create Message Content
   * @request POST:/v1/admin/messages/{messageId}/contents/{languageId}
   * @secure
   */
  createMessageContent = (
    messageId: number,
    languageId: number,
    data: MessageContentDto,
    params: RequestParams = {},
  ) =>
    this.http.request<MessageContentDto, any>({
      path: `/v1/admin/messages/${messageId}/contents/${languageId}`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description 기존 메시지 콘텐츠를 삭제합니다.
   *
   * @tags AdminMessageService
   * @name DeleteMessageContent
   * @summary Delete Message Content
   * @request DELETE:/v1/admin/messages/{messageId}/contents/{languageId}
   * @secure
   */
  deleteMessageContent = (messageId: number, languageId: number, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/messages/${messageId}/contents/${languageId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminMessageService
   * @name GetMessages
   * @summary Get Messages
   * @request GET:/v1/admin/messages
   * @secure
   */
  getMessages = (
    query?: {
      searchKeyword?: string;
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 20
       */
      size?: number;
      /** Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<MessageDto[], any>({
      path: `/v1/admin/messages`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description 새로운 메시지를 생성합니다.
   *
   * @tags AdminMessageService
   * @name CreateMessage
   * @summary Create Message
   * @request POST:/v1/admin/messages
   * @secure
   */
  createMessage = (data: MessageRequestDto, params: RequestParams = {}) =>
    this.http.request<MessageDto, any>({
      path: `/v1/admin/messages`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminMessageService
   * @name GetMessageContents
   * @summary Get Message Contents
   * @request GET:/v1/admin/messages/{messageId}/contents
   * @secure
   */
  getMessageContents = (messageId: number, params: RequestParams = {}) =>
    this.http.request<MessageContentDto[], any>({
      path: `/v1/admin/messages/${messageId}/contents`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
}
